function convertToMinutes() {
  let time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (time.length) {
    const hours = time.split(':')[0];
    const minutes = time.split(':')[1];
    return parseInt(hours * 60, 10) + parseInt(minutes, 10);
  }
  return 0;
}
export default convertToMinutes;
//# sourceMappingURL=convertToMinutes.js.map